/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import PageContainer from "../../components/Home/layout/PageContainer";
import zaincashLogo from "../../assets/zaincash.png";
import qicardLogo from "../../assets/qicard.png";

export default function PaymentUI({
  COLORS,
  isArabic,
  isMobile,
  isUpgrade,
  selectedMethod,
  setSelectedMethod,
  loading,
  handlePayment,
}) {
  return (
    <PageContainer title={isArabic ? "الدفع" : "Payment"}>
      <div
        className="text-center"
        style={{
          color: COLORS.textLight,
          fontFamily: "'Tajawal', 'Cairo', sans-serif",
          marginTop: "20px",
        }}
      >
        <h5
          style={{
            color: COLORS.gold,
            fontWeight: "700",
            marginBottom: isMobile ? "30px" : "40px",
            fontSize: isMobile ? "1.1rem" : "1.3rem",
            padding: isMobile ? "0 10px" : "0",
          }}
        >
         {isUpgrade
  ? isArabic
    ? "يرجى اختيار طريقة الدفع لإتمام ترقية الخطة."
    : "Please select a payment method to complete the plan upgrade."
  : isArabic
  ? "يرجى اختيار طريقة الدفع لإتمام الدفع."
  : "Please select a payment method to complete the payment."}

        </h5>

        <div
          className="d-flex justify-content-center align-items-center gap-4 mt-4"
          style={{
            flexDirection: isMobile ? "column" : "row",
            flexWrap: "wrap",
          }}
        >
          {/* QiCard */}
          <div
            onClick={() => setSelectedMethod("qicard")}
            className="shadow-lg"
            style={{
              width: isMobile ? "100%" : "260px",
              maxWidth: "260px",
              height: "180px",
              borderRadius: "18px",
              background:
                selectedMethod === "qicard"
                  ? "linear-gradient(135deg, rgba(242,180,65,0.25), rgba(255,255,255,0.12))"
                  : "rgba(255,255,255,0.07)",
              border:
                selectedMethod === "qicard"
                  ? `2px solid ${COLORS.gold}`
                  : "1px solid rgba(255,255,255,0.15)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              transform:
                selectedMethod === "qicard" ? "scale(1.05)" : "scale(1)",
              boxShadow:
                selectedMethod === "qicard"
                  ? "0 10px 25px rgba(242,180,65,0.35)"
                  : "0 4px 15px rgba(0,0,0,0.25)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={qicardLogo} width="100" height="65" />
            <h5 className="mt-3 fw-bold" style={{ color: COLORS.gold }}>
              {isArabic ? "كي كارد" : "QiCard"}
            </h5>
          </div>

          {/* ZainCash */}
          <div
            onClick={() => setSelectedMethod("zaincash")}
            className="shadow-lg"
            style={{
              width: isMobile ? "100%" : "260px",
              maxWidth: "260px",
              height: "180px",
              borderRadius: "18px",
              background:
                selectedMethod === "zaincash"
                  ? "linear-gradient(135deg, rgba(242,180,65,0.25), rgba(255,255,255,0.12))"
                  : "rgba(255,255,255,0.07)",
              border:
                selectedMethod === "zaincash"
                  ? `2px solid ${COLORS.gold}`
                  : "1px solid rgba(255,255,255,0.15)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              transform:
                selectedMethod === "zaincash" ? "scale(1.05)" : "scale(1)",
              boxShadow:
                selectedMethod === "zaincash"
                  ? "0 10px 25px rgba(242,180,65,0.35)"
                  : "0 4px 15px rgba(0,0,0,0.25)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={zaincashLogo} width="100" height="65" />
            <h5 className="mt-3 fw-bold" style={{ color: COLORS.gold }}>
              {isArabic ? "زين كاش" : "ZainCash"}
            </h5>
          </div>
        </div>

        <button
          onClick={handlePayment}
          disabled={loading}
          className="btn fw-semibold px-5 py-2 mt-5"
          style={{
            background: COLORS.gold,
            color: COLORS.darkPurple,
            borderRadius: "12px",
            fontWeight: "700",
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading
            ? isArabic
              ? "جارٍ المعالجة..."
              : "Processing..."
            : isArabic
            ? "إتمام الدفع"
            : "Complete Payment"}
        </button>
      </div>
    </PageContainer>
  );
}
